import * as types from '../types/companies'
import { createReducer, updateDeepState } from '../handlers'

const initCompaniesState = {
}

export default createReducer(initCompaniesState, {
  [types.UPDATE_EXISTING_COMPANY](state, action) {
    return updateDeepState(state, action.company)
  },
  [types.SET_ALL_COMPANIES](state, action) {
    return Object.assign({}, action.companies)
  },
  [types.ADD_NEW_COMPANY](state, action) {
    return Object.assign({}, state, { [action.company._id]: action.company })
  },
  [types.DELETE_COMPANY](state, action) {
    delete state[action.company._id]
    return Object.assign({}, state)
  },
})
